<template>
  <div class="expense-histories">
    <ExpenseHistoryRecord
      v-for="(historyRecord, index) in expenseHistories"
      :key="historyRecord.id"
      :history-record="historyRecord"
      :num="expenseHistories.length - index"
    />
  </div>
</template>

<script>
import ExpenseHistoryRecord from './ExpenseHistoryRecord';
export default {
  name: 'ExpenseHistoryList',
  components: { ExpenseHistoryRecord },
  computed: {
    expenseHistories() {
      return this.$store.state.expensesState.expenseDetailsState.expenseHistories;
    }
  }
};
</script>
